<template>
    <div>
        {{this.dataForTable}}
        <a-table :columns="columns" :dataSource="data" rowKey='bankPaymentId' :scroll="{ x: 1500  }"
        :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">

            <h6 slot="status" slot-scope="status, record">
                <b-badge href="#" @click="useAction(record.bankPaymentId,status)" pill :variant="getStatus('bankPayment',status).color">{{getStatus('bankPayment',status).name}}</b-badge>
            </h6>
        </a-table>
         <a-modal v-model="modelShowDetail" title="ข้อมูลรายการที่จับคู่" ok-text="ยืนยัน" cancel-text="ยกเลิก" showCancelButton="false"  @ok="useModal">
            <div class="mb-5">
                <h5 class="mb-4">
                    <strong>รายละเอียดรายการที่จับคู่กับ # {{(!this.datatransection.bankPaymentId)?"ไม่พบข้อมูล":this.datatransection.bankPaymentId }}</strong>
                </h5>
                <dl class="row">
                    <dt class="col-sm-3">รหัสรายการ :</dt>
                    <dd class="col-sm-9">{{(!this.datatransection.depositCode)?"ไม่พบข้อมูล":this.datatransection.depositCode }}</dd>

                    <dt class="col-sm-3">บัญชีลูกค้า :</dt>
                    <dd class="col-sm-9">{{(!this.datatransection.userBankTranfer)?"ไม่พบข้อมูล":this.datatransection.userBankTranfer }}</dd>

                    <dt class="col-sm-3">บัญชีระบบ :</dt>
                    <dd class="col-sm-9">{{(!this.datatransection.systemBankTranfer)?"ไม่พบข้อมูล":this.datatransection.systemBankTranfer }}</dd>

                    <dt class="col-sm-3 text-truncate">จำนวนเงิน :</dt>
                    <dd class="col-sm-9">{{(!this.datatransection.amount)?"ไม่พบข้อมูล":this.datatransection.amount }}</dd>

                    <dt class="col-sm-3">สถานะ :</dt>
                    <dd class="col-sm-9"><b-badge pill :variant="(!this.datatransection.color)?'info':this.datatransection.color">{{(!this.datatransection.status)?"ไม่พบข้อมูล":this.datatransection.status }}</b-badge></dd>
                </dl>
            </div>
        </a-modal>
    </div>
</template>

<script>
import moment from 'moment'
import apiClient from '@/services/api'
import { getName } from '@/utils/status'
import Swal from 'sweetalert2'
// const Toast = Swal.mixin({
//   toast: true,
//   position: 'top-end',
//   showConfirmButton: false,
//   timer: 3000,
//   timerProgressBar: true,
//   didOpen: (toast) => {
//     toast.addEventListener('mouseenter', Swal.stopTimer)
//     toast.addEventListener('mouseleave', Swal.resumeTimer)
//   },
// })
export default {
  props: [
    'dataForTable',
  ],
  data() {
    return {
      modelShowDetail: false,
      data: [],
      columns: [{
        title: '',
        key: 'bankPaymentId',
        dataIndex: 'bankPaymentId',
      },
      {
        title: 'คู่ค้า',
        key: 'operatorName',
        dataIndex: 'operatorName',
      },
      {
        title: 'บัญชีระบบ',
        key: 'bankServiceSystem',
        dataIndex: 'bankServiceSystem',
      },
      {
        title: 'เวลาโอน',
        key: 'datetimeTranfer',
        dataIndex: 'datetimeTranfer',
        customRender: (text, row, index) => {
          return moment(text).format('DD/MM/YYYY HH:mm:ss')
        },
      },
      {
        title: 'เงินเข้า',
        key: 'amountInCome',
        dataIndex: 'amountInCome',
        customRender: (text, row, index) => {
          if (text !== '-') {
            const amountIncomes = parseFloat(text)
            return amountIncomes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          }
          return text
        },
      },
      {
        title: 'เงินออก',
        key: 'amountOutCome',
        dataIndex: 'amountOutCome',
        customRender: (text, row, index) => {
          if (text !== '-') {
            const amountOutComes = parseFloat(text)
            return amountOutComes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          }
          return text
        },
      },
      {
        title: 'รายละเอียด',
        key: 'detail',
        dataIndex: 'detail',
        scopedSlots: {
          customRender: 'detail',
        },
      },
      {
        title: 'สถานะ',
        key: 'status',
        dataIndex: 'bankPaymentStatus',
        scopedSlots: {
          customRender: 'status',
        },
      },
      {
        title: 'ธนาคารที่โอน',
        key: 'detailBankNumber',
        dataIndex: 'detailBankNumber',
        scopedSlots: {
          customRender: 'detailBankNumber',
        },
      },
      {
        title: 'วันที่สร้าง',
        key: 'createdAt',
        dataIndex: 'createdAt',
        customRender: (text, row, index) => {
          return moment(text).format('DD/MM/YYYY HH:mm:ss')
        },
      },
      ],
      datatransection: {
        bankPaymentId: null,
        depositCode: null,
        amount: null,
        userBankTranfer: null,
        systemBankTranfer: null,
        status: null,
        color: null,
      },
    }
  },
  watch: {

  },
  methods: {
    async getData() {
      const dataStatement = {
        bankType: 'created',
        startDate: null,
        endDate: null,
        operatorCode: null,
        bankServiceId: null,
        status: null,
        keyword: null,
        statusKey: 1,

      }
      await apiClient.post('/statement/getData', dataStatement).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.data = res.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
                    `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    reload() {
      this.getData()
      this.$emit('clear-reload')
    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    useAction(bankPaymentId, status) {
      if (status === '000') this.showSucces(bankPaymentId)
      // if (status === '003') this.showInfo(bankPaymentId)
      // if (status === '004') this.reStatus(bankPaymentId, '001')
    },
    async showSucces(bankPaymentId) {
      const dataTransection = {
        bankPaymentId: bankPaymentId,
        dataType: this.pageType,
      }

      await apiClient.post('/statement/getTransection', dataTransection).then(response => {
        this.datatransection = {
          bankPaymentId: null,
          depositCode: null,
          amount: null,
          userBankTranfer: null,
          systemBankTranfer: null,
          status: null,
          color: null,
        }

        const res = response.data
        if (res.code === '000') {
          this.useModal()
          const getData = res.responseData.data[0]

          const getnameStatus = getName(this.pageType, getData.transectionStatus)

          this.datatransection = {
            bankPaymentId: bankPaymentId,
            depositCode: getData.transectionCode,
            amount: getData.amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
            userBankTranfer: getData.bankServiceUser,
            systemBankTranfer: getData.bankServiceSystem,
            status: getnameStatus[0].name,
            color: getnameStatus[0].color,
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
                `Request failed: ${error}`,
        )
      })
    },
    useModal(e) {
      this.modelShowDetail = !this.modelShowDetail
    },
  },
  async created() {
    await this.getData()
  },
}
</script>

<style>

</style>
